module.exports = __webpack_public_path__ + "img/campfire.99b00ac9.svg";